module.exports = __webpack_public_path__ + "img/qr-code.3205c660.png";